import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldMomentsVariables = Types.Exact<{
  exhibitionId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiWorldMoments = { worldMoments: { page: number, totalPages: number, totalItems: number, items: Array<{ id: number, name: string, startsAt: string, posterUrl: string, description: string | null, takeRateInBasisPoints: number, worldId: number, stats: { itemCount: number } }> } };



export const ApiWorldMomentsDocument = /*#__PURE__*/ `
    query WorldMoments($exhibitionId: Int!, $page: Int, $perPage: Int) {
  worldMoments: momentsByExhibition(
    exhibitionId: $exhibitionId
    page: $page
    perPage: $perPage
  ) {
    items {
      id
      name
      startsAt
      posterUrl
      description
      takeRateInBasisPoints
      worldId
      stats {
        itemCount
      }
    }
    page
    totalPages
    totalItems
  }
}
    `;

export const useWorldMoments = <
      TData = ApiWorldMoments,
      TError = ClientError
    >(
      variables: ApiWorldMomentsVariables,
      options?: Omit<UseQueryOptions<ApiWorldMoments, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldMoments, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldMoments, TError, TData>(
      {
    queryKey: ['WorldMoments', variables],
    queryFn: apiFetcher<ApiWorldMoments, ApiWorldMomentsVariables>(ApiWorldMomentsDocument, variables),
    ...options
  }
    )};

useWorldMoments.getKey = (variables: ApiWorldMomentsVariables) => ['WorldMoments', variables];

export const useInfiniteWorldMoments = <
      TData = InfiniteData<ApiWorldMoments>,
      TError = ClientError
    >(
      variables: ApiWorldMomentsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldMoments, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldMoments, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldMoments, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldMoments.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldMoments, ApiWorldMomentsVariables>(ApiWorldMomentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldMoments.getKey = (variables: ApiWorldMomentsVariables) => ['WorldMoments.infinite', variables];


useWorldMoments.fetcher = (variables: ApiWorldMomentsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldMoments, ApiWorldMomentsVariables>(ApiWorldMomentsDocument, variables, options);
